import { Button, styled } from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import BasicSearch from "../../components/search/basicSearch";
import FilterMenu from "./filterMenu";

const MainSection = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: "10px",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "flex-start",
    gap: "10px",
  },
}));

const InvoiceFilter = ({
  findForSearchQuery,
  apply,
  reset,
  search: newSearch,
  isFilterApplied,
  filterData,
  setFilterData,
}) => {
  const [search, setSearch] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      findForSearchQuery(search);
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    setSearch(newSearch);
  }, [newSearch]);

  return (
    <MainSection>
      <BasicSearch
        text="Search Transactions..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={handleKeyPress}
      />

      <Button
        variant="contained"
        size="small"
        sx={{
          boxShadow: "none",
        }}
        onClick={() => findForSearchQuery(search)}
      >
        Search
      </Button>

      <Button
        variant="outlined"
        size="small"
        sx={{
          boxShadow: "none",
        }}
        id="filter-button"
        aria-controls={open ? "filter-button" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        filters
      </Button>

      <FilterMenu
        anchorEl={anchorEl}
        open={open}
        handleClose={handleClose}
        reset={reset}
        apply={apply}
        isFilterApplied={isFilterApplied}
        filterData={filterData}
        setFilterData={setFilterData}
      />
    </MainSection>
  );
};

InvoiceFilter.propTypes = {
  findForSearchQuery: PropTypes.func,
  apply: PropTypes.func,
  reset: PropTypes.func,
  search: PropTypes.string,
  isFilterApplied: PropTypes.bool,
  filterData: PropTypes.object,
  setFilterData: PropTypes.func,
};

export default InvoiceFilter;
